import React, { useEffect, useState, useRef } from "react";
import { Toast } from "primereact/toast";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { useHistory } from "react-router-dom";
import { InputTextarea } from "primereact/inputtextarea";
import { validateInputText } from "../../../utilities/ValidateUtil";
import { DialogConfirm, DialogViewPic } from "../../../components/DialogService/DialogService";
import { FooterButtonSigle, FooterButtonCustomLabel } from "../../../components/FooterButton/FooterButton";
import { Loading } from "../../../components/Loading/Loading";
import { dataUserSession } from "../../../utilities/dataSession";

//PAGE
import P203List_1 from "./P203List_1";
import P203List_2 from "./P203List_2";

//SERVICE
import { pSupervisorReport1_Info, pSupervisorReport1Update } from "../../../service/200/P203Service";
import { genPhotoList } from "../../../service/GEN/GenService";
import ValidateService from "../../../components/ValidateService/ValidateService";

export default function P203() {
    const toast = useRef(null);
    const op = useRef(null);
    const history = useHistory();

    const [loading, setLoading] = useState(false);
    const [errData, setErrData] = useState(null);
    const [submitted, setSubmitted] = useState(false);

    // Dialog
    const [confirmDialog, setConfirmDialog] = useState(false);
    const [dialogOption, setdialogOption] = useState({
        header: "",
        content: "",
        onConfirm: () => {},
        onCancle: () => {},
        footerBtn: () => {},
    });

    // DATA
    const [formArray, setFormArray] = useState([]);
    const [dataTbImage, setDataTbImage] = useState([]);
    const [supervisorReason, setSupervisorReason] = useState("");

    // SEARCH
    const [searchData, setSearchData] = useState({
        requestNo: "",
        userId: "",
    });

    // View Pic
    const [dialogPic, setDialogPic] = useState({ dialog: false, pic: "", show: false });

    useEffect(() => {
        if (dataUserSession()) {
            if (history.location.state) {
                setSearchData({ ...history.location.state, userId: dataUserSession().userId });
            } else {
                history.push("/200");
                // setSearchData({ requestNo: "R651600003", userId: dataUserSession().userId });
            }
        } else {
            history.push("/login");
        }
    }, []);

    useEffect(() => {
        if (searchData.requestNo != "") {
            getSupervisorReport1_Info();
            getGenPhotoList();
        }
    }, [searchData]);

    const handlerSettingDialogConfirm = (header, content) => {
        setdialogOption({
            ...dialogOption,
            header: header,
            content: content,
            footerBtn: () => footerButtonSingle(),
            onCancle: () => setConfirmDialog(false),
        });
        setConfirmDialog({ open: true });
    };

    const getSupervisorReport1_Info = () => {
        setLoading(true);

        const req = {
            requestNo: searchData.requestNo,
            userId: searchData.userId,
        };
        pSupervisorReport1_Info(req).then(
            (res) => {
                // console.log(res);
                setLoading(false);
                if (res !== undefined) {
                    let temp = [];
                    let index = 0;
                    res.data.forEach((element) => {
                        temp.push({
                            ...element,
                            index: index,
                        });
                        index++;
                    });
                    if (res.data.length > 0) setSupervisorReason(res.data[0].supervisorReason);
                    setFormArray(temp);
                } else {
                    showMessages("error", `เกิดข้อผิดพลาด `, `ไม่พบข้อมูล`);
                }
            },
            function (err) {
                setLoading(false);
                setErrData(err);
            }
        );
    };

    const getGenPhotoList = () => {
        const req = {
            userId: searchData.userId,
            requestNo: searchData.requestNo,
            photoType: "C001",
        };
        genPhotoList(req).then(
            (res) => {
                setLoading(false);

                if (res !== undefined) {
                    let temp = [];
                    let index = 0;
                    if (res.data.length) {
                        res.data.forEach((element) => {
                            temp.push({
                                ...element,
                                index: index,
                            });
                            index++;
                        });
                        setDataTbImage(temp);
                    }
                } else {
                    showMessages("error", `เกิดข้อผิดพลาด `, `ไม่พบข้อมูล`);
                }
            },
            function (err) {
                setLoading(false);
                setErrData(err);
            }
        );
    };
    const footerButtonSingle = () => {
        const con = () => {
            // alert("/200");
            history.push("/200");
            setConfirmDialog(false);
        };
        return <FooterButtonSigle btnLabel="ปิด" icon="pi pi-check" onClick={() => con()} />;
    };

    const validation = (val) => {
        if (val === "") {
            setSubmitted(true);
            return false;
        } else {
            setSubmitted(false);
            return true;
        }
    };
    const submitForm = (act) => {
        setLoading(true);
        const req = {
            actionCode: act,
            requestNo: searchData.requestNo,
            supervisorReason: supervisorReason,
            userId: searchData.userId,
            recordStamp: setValForm("recordStamp"),
        };
        // console.log(req);
        pSupervisorReport1Update(req).then(
            (res) => {
                setLoading(false);
                if (res.status === 200) {
                    handlerSettingDialogConfirm(res.data[0].statusCode === "C" ? "บันทึกสมบูรณ์" : "มีข้อผิดพลาด", res.data[0].statusText);
                } else {
                    showMessages("error", "เกิดข้อผิดพลาด", "บันทึกข้อมูลการรายงานผลผิดพลาด");
                }
            },
            function (err) {
                if (err.response && err.response.data.status === 401) {
                    alert(JSON.stringify("เนื่องจาก Authorized หมดอายุ กรุณาเข้าสู่ระบบใหม่"));
                    window.location.href = "/login";
                } else {
                    showMessages("error", `เกิดข้อผิดพลาด : ${err} `, "บันทึกข้อมูลการรายงานผลผิดพลาด");
                }
                setLoading(false);
            }
        );
    };

    const showMessages = (severity = "error", summary = "", detail = "") => {
        toast.current.show({ severity: severity, summary: summary, detail: detail, life: 10000 });
    };

    const setValForm = (_key) => {
        return formArray.length > 0 ? formArray[0][_key] : "";
    };

    const viewImage = (event) => {
        setDialogPic({
            dialog: true,
            show: true,
            pic: event.photoPath,
        });
    };

    const toFixed = (val) => {
        if (val !== "") {
            return parseFloat(val).toFixed(3);
        }
    };

    const disPlayMode = () => {
        // return false;
        return setValForm("displayMode") === "Y" ? true : false;
    };

    const footerButtonCon = (act) => {
        return (
            <FooterButtonCustomLabel
                labelCon="ยืนยัน"
                lableCan="ยกเลิก"
                onClickOk={() => {
                    submitForm(act);
                    setConfirmDialog({ open: false });
                }}
                onClickCancle={() => setConfirmDialog(false)}
            />
        );
    };
    const handlerSettingDialogConfirm_2 = (key, _content) => {
        if (key === "R") {
            if (!validation(supervisorReason)) {
                return true;
            }
        }
        setdialogOption({
            ...dialogOption,
            header: "",
            content: _content,
            footerBtn: () => footerButtonCon(key),
            onCancle: () => setConfirmDialog(false),
        });
        setConfirmDialog({ open: true });
    };

    return (
        <>
            <Loading loading={loading} />
            <ValidateService err={errData} setErr={setErrData} />
            <div className="p-grid crud-demo">
                <Toast ref={toast} position="top-right" />
                <div className="p-col-12">
                    <div className="card">
                        <div className="p-fluid p-formgrid p-grid">
                            <div className="p-field p-col-12 p-md-4">
                                <label htmlFor="requestNo">เลขที่ใบแจ้งฯ</label>
                                <InputText id="requestNo" type="text" disabled={true} maxLength="20" value={setValForm("requestNo")} />
                            </div>
                            <div className="p-field p-col-12 p-md-4">
                                <label htmlFor="requestType">ประเภทงาน</label>
                                <InputText id="requestType" type="text" disabled={true} maxLength="100" value={setValForm("requestType")} />
                            </div>
                        </div>
                        <div className="p-fluid p-formgrid p-grid">
                            <div className="p-field p-col-12 p-md-4">
                                <label htmlFor="contractNO">เลขที่สัญญา</label>
                                <InputText id="contractNO" type="text" disabled={true} maxLength="20" value={setValForm("contractNO")} />
                            </div>
                            <div className="p-field p-col-12 p-md-4">
                                <label htmlFor="routeName">เส้นทาง</label>
                                <InputText id="routeName" type="text" disabled={true} maxLength="200" value={setValForm("routeName")} />
                            </div>
                        </div>
                        <hr />
                        <br />
                        <div className="p-fluid p-formgrid p-grid">
                            <div className="p-field p-col-12 p-md-4">
                                <label htmlFor="locationBegin">บริเวณก่อสร้าง</label>
                                {/* <InputText id="locationBegin" type="text" disabled={true} maxLength="20" value={toFixed(setValForm("locationBegin"))} /> */}
                                <InputText id="locationBegin" type="text" disabled={true} maxLength="20" value={setValForm("locationBegin")} />
                            </div>
                            <div className="p-field p-col-12 p-md-4">
                                <label htmlFor="locationEnd">ถึง</label>
                                {/* <InputText id="locationEnd" type="text" disabled={true} maxLength="20" value={toFixed(setValForm("locationEnd"))} /> */}
                                <InputText id="locationEnd" type="text" disabled={true} maxLength="20" value={setValForm("locationEnd")} />
                            </div>
                        </div>
                        <div className="p-fluid p-formgrid p-grid">
                            <div className="p-field p-col-12 p-md-4">
                                <label htmlFor="operateTimeBegin">วันที่เวลาขอออกปฏิบัติงานจาก</label>
                                <InputText id="operateTimeBegin" type="text" disabled={true} maxLength="10" value={setValForm("operateTimeBegin")} />
                            </div>
                            <div className="p-field p-col-12 p-md-4">
                                <label htmlFor="operateTimeEnd">วันที่เวลาขอออกปฏิบัติงานถึง</label>
                                <InputText id="operateTimeEnd" type="text" disabled={true} maxLength="10" value={setValForm("operateTimeEnd")} />
                            </div>
                        </div>
                        <div className="p-fluid p-formgrid p-grid">
                            <div className="p-field p-col-12 p-md-4">
                                <label htmlFor="foremanName">หัวหน้างาน</label>
                                <InputText id="foremanName" type="text" disabled={true} maxLength="100" value={setValForm("foremanName")} />
                            </div>
                        </div>
                        <div className="p-fluid p-formgrid p-grid">
                            <div className="p-field p-col-12 p-md-4">
                                <label htmlFor="reportDtBegin">วันที่เวลาออกปฏิบัติงานจาก</label>
                                <InputText id="reportDtBegin" type="text" disabled={true} maxLength="10" value={setValForm("reportDtBegin")} />
                            </div>
                            <div className="p-field p-col-12 p-md-4">
                                <label htmlFor="reportDtEnd">วันที่เวลาออกปฏิบัติงานถึง</label>
                                <InputText id="reportDtEnd" type="text" disabled={true} maxLength="10" value={setValForm("reportDtEnd")} />
                            </div>
                        </div>
                        <br />
                        <P203List_1 dataTable={formArray} />
                        <label>รูปภาพ</label>
                        <hr />
                        <br />
                        <P203List_2 dataTable={dataTbImage} viewImage={viewImage} />
                        <br />
                        <div className="p-fluid p-formgrid p-grid">
                            <div className="p-field p-col-12 p-md-7">
                                <label htmlFor="supervisorReason">เหตุผล</label>
                                <span style={{ color: "red" }}>*</span>
                                <InputTextarea className={submitted && !supervisorReason ? "p-invalid" : ""} id="supervisorReason" type="text" rows="4" maxLength="500" value={supervisorReason} onChange={(e) => setSupervisorReason(e.target.value)} disabled={disPlayMode()} />
                                {submitted && !supervisorReason && validateInputText("supervisorReason", "เหตุผล")}
                            </div>
                        </div>
                        <div className="p-grid" style={{ textAlign: "center" }}>
                            <div className="p-col-12">
                                <Button className="p-button-success p-button p-mr-2 p-mb-2" icon="pi pi-check" label="อนุมัติ" style={{ width: 170 }} onClick={() => handlerSettingDialogConfirm_2("A", "ต้องการอนุมัติรายงานผล หรือไม่")} disabled={disPlayMode()} />

                                <Button
                                    className="p-button-warning p-button p-mr-2 p-mb-2"
                                    icon="pi pi-ban"
                                    label="ส่งกลับแก้ไข"
                                    // style={{ marginLeft: '5px' }}
                                    style={{ width: 170, marginLeft: "5px" }}
                                    onClick={() => handlerSettingDialogConfirm_2("R", "ต้องการส่งกลับผู้รับเหมาแก้ไข หรือไม่")}
                                    disabled={disPlayMode()}
                                />
                                <Button
                                    className="p-button-secondary p-button p-mr-2 p-mb-2"
                                    icon="pi pi-arrow-left"
                                    label="กลับหน้าจอหลัก"
                                    // style={{ marginLeft: '5px' }}
                                    style={{ width: 170, marginLeft: "5px" }}
                                    onClick={() => history.push("/200")}
                                />
                            </div>
                        </div>
                    </div>
                    <DialogConfirm visible={confirmDialog.open} header={dialogOption.header} modal footer={dialogOption.footerBtn} onHide={() => setConfirmDialog(false)} textContent={dialogOption.content} />
                    <DialogViewPic dialog={dialogPic} data={dialogPic.pic} modal setDialogPic={setDialogPic} />
                </div>
            </div>
        </>
    );
}
